import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { VideoStreamService } from '../services/video-stream.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vnc-dialog',
  templateUrl: './vnc-dialog.component.html',
  styleUrls: ['./vnc-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VncDialogComponent implements OnInit, OnDestroy {
  iframeUrl: string = '';
  errorMessage: string = '';
  private sourceOneIpSubscription?: Subscription;

  constructor(private videoStreamService: VideoStreamService) { }

  ngOnInit() {
    this.sourceOneIpSubscription = this.videoStreamService.sourceOneIpNotification().subscribe((deviceIp) => {
      if (deviceIp) {
        this.controlVideo(deviceIp);
      }
    });
  }

  async controlVideo(deviceIp: string) {
    if (!deviceIp) {
      this.errorMessage = 'Device IP not available.';
      return;
    }

    let response = await this.videoStreamService.controlVideo(deviceIp, false);
    if (response.success === true) {
      this.iframeUrl = response.data.url;
      this.errorMessage = '';
    } else {
      this.errorMessage = response.errorMessages[0].message;
    }
  }

  ngOnDestroy() {
    this.sourceOneIpSubscription?.unsubscribe();
  }
}
